<template>
  <div id="registermain" v-loading="this.loading" element-loading-text="加载中">
    <span class="titleline" @click="checkLogin()">已有账号，立即登陆</span>
    <label class="loginLable" style="margin-bottom: 8%;margin-top: 5%;">用户注册</label>
    <el-form ref="registerForm" :model="registerForm" :rules="registerFormRules">
      <el-form-item prop="username">
        <el-input ref="input" prefix-icon="iconfont icon-login-username" v-model="registerForm.username" placeholder="请输入手机号"
          style="width: 65%;">
        </el-input>
        <button class="yzmbtn" type="button" @click="getMessageCode()" v-text="messageCodeText" :disabled="mobileBtnDisabled"></button>
      </el-form-item>

      <el-form-item prop="yanzhengma">
        <el-input prefix-icon="iconfont icon-login-password" class="iconStyle" v-model="registerForm.yanzhengma"
          placeholder="请输入验证码">
        </el-input>
      </el-form-item>

      <el-form-item prop="password">
        <el-input prefix-icon="iconfont icon-login-password" class="iconStyle" v-model="registerForm.password"
          placeholder="请输入密码" type="password">
        </el-input>
      </el-form-item>

      <el-form-item prop="password1">
        <el-input prefix-icon="iconfont icon-login-password" class="iconStyle" v-model="registerForm.password1"
          placeholder="确认密码" type="password">
        </el-input>
      </el-form-item>


      <div class="div1">
        <div>
          <span @click="checkForgot()" class="span1">
            忘记密码</span>
          <span @click="checkForgotUsername()" class="span2">|
            忘记用户名</span>
        </div>
      </div>
      <div class="login-btn" style="margin-top: 40px;">
        <el-button size="medium" @click="register('registerForm')" type="primary">注册</el-button>
      </div>

    </el-form>
  </div>
</template>

<script>
  var code; //在全局定义验证码

  export default {
    name: 'registermain',
    data() {
      var validatePhone = (rule, value, callback) => {
        //
        if (value == "" || value == null && num == 0) {
          return callback(new Error('请输入手机号'));
        } else if (!/^1[345789]\d{9}$/.test(value)) {
          return callback(new Error('请输入正确手机号'));
        } else {
          callback();
        }
      };
      var validateYan = (rule, value, callback) => {
        if (value == "" || value == null) {
          return callback(new Error('请输入验证码'));
        } else if (value == this.messageCodeReal && this.messageCodeReal != "") {
          callback();
        } else {
          return callback(new Error('验证码错误'));
        }
      };

      // var validatePass1 = (rule, value, callback) => {
      //
      // var regu = "^[0-9a-zA-Z]{6,16}$";
      // var re = new RegExp(regu);
      // if (value == "" || value == null) {
      //   return callback(new Error('请输入密码'));
      // } else if (re.test(value)) {
      //   callback();
      // } else {
      //   return callback(new Error('6-16位数字和字母的组合'));
      // }
      // };

      var validatePass2 = (rule, value, callback) => {
        if (value == "" || value == null) {
          return callback(new Error('请再次输入密码'));
        } else if (value == this.registerForm.password && value != "" && value != null) {
          callback();
        } else {
          return callback(new Error('两次密码输入不一致'));
        }
      };
      return {
        loading: false,
        registerForm: {
          usertype: "COM",
          username: "",
          password: "",
          password1: "",
          yanzhengma: ""
        },
        passWord: "",
        registerFormRules: {
          username: [{
            validator: validatePhone,
            trigger: "blur"
          }],
          yanzhengma: [{
            validator: validateYan,
            trigger: "blur"
          }],
          password: [{
              required: true,
              message: "请输入密码",
              trigger: "blur"
            },
            {
              min: 8,
              message: "密码最少8位",
              trigger: "blur"
            },
            {
              pattern: /(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,30}/,
              message: "密码必须包含数字、字母、特殊字符至少三种",
              trigger: "blur"
            }
          ],
          password1: [{
            validator: validatePass2,
            trigger: "blur"
          }],
        },
        messageCodeText: "获取验证码",
        mobileBtnDisabled: false,
        messageCodeReal: "",
        time: 60,
        num: 0,
      }
    },
    //实现窗口自适应 add by yushch 20191227
    mounted() {
      let htmlWidth = document.documentElement.clientWidth || document.body.clientWidth;
      //获取htmlDom
      let htmlDom = document.getElementsByTagName('html')[0];
      //设置html的font-size
      htmlDom.style.fontSize = htmlWidth / 120 + 'px';
      window.addEventListener('resize', (e) => {
        let htmlWidth = document.documentElement.clientWidth || document.body.clientWidth;
        //获取htmlDom
        let htmlDom = document.getElementsByTagName('html')[0];
        //设置html的font-size
        htmlDom.style.fontSize = htmlWidth / 120 + 'px';
      })
    },
    created() {

    },
    methods: {
      init: function() {
        this.$refs["registerForm"].resetFields()
      },
      getCursor: function() {
        el.querySelector('input').focus()
      },
      checkLogin: function() {
        this.$parent.isLogin = true;
        this.$parent.isRegister = false;
        this.$parent.isForgot = false;
        this.$parent.isForgotUsername = false;
        this.$parent.$refs.loginmain.init();
      },
      checkForgot: function() {
        this.$parent.isLogin = false;
        this.$parent.isRegister = false;
        this.$parent.isForgot = true;
        this.$parent.isForgotUsername = false;
        this.$parent.$refs.forgetpasswordmain.init();
      },
      checkForgotUsername: function() {
        this.$parent.isLogin = false;
        this.$parent.isRegister = false;
        this.$parent.isForgot = false;
        this.$parent.isForgotUsername = true;
        this.$parent.$refs.forgetusernamemain.init();
      },
      mobileCheck() {
        var name = "";
        if (this.registerForm.username != null && this.registerForm.username != "") {
          name = this.registerForm.username;
        }
        if (!/^1[345789]\d{9}$/.test(name)) {
          //用户名不正确，显示红字提醒
          this.usernameAlertFlag = true;
          return false;
        } else {
          this.usernameAlertFlag = false;
          return true;
        }
      },
      //注册
      register: function(formName) {
        this.passWord = this.registerForm.password;
        this.$refs[formName].validate(valid => {
          let vm = this;
          if (valid) {
            vm.loading = true;
            var params = {
              username: vm.registerForm.username,
              password: vm.registerForm.password,
              usertype: "APP",
              deptid: "80"
            };
            vm.$axios.post("/signin/insertByVO", params).then(function(res) {
                if(res.data.code = '00000000') {
                  this.$alert('注册成功', '提示', {
                    confirmButtonText: '确定',
                    callback: action => {
                      this.$parent.userName = res.data.result.username;
                      //vm.changeForm("loginFlag");
                      this.$parent.checkLogin();
                      vm.loading = false;
                    }
                  });
                  this.$refs[formName].resetFields()
                }
              }.bind(vm),function(error) {
                console.log(error);
              }
            );
          }
        });
      },
      //获取手机验证码
      getMessageCode: function() {
        this.$nextTick(() => { //自动获取焦点 element组件autofocus失效
          this.$refs.input.$refs.input.focus()
        })
        if (this.registerForm.username == "" || this.registerForm.username == null) {
          this.$nextTick(() => { //自动获取焦点 element组件autofocus失效
            this.$refs.input.$refs.input.blur()
          })
        } else {
          let vm = this;
          vm.messageCode = "";
          if (vm.mobileCheck()) {
            vm.messageCodeText = "发送中...";
            vm.mobileBtnDisabled = true;
            vm.$axios.get("/signin/getUsernameNum/" + vm.registerForm.username + "/static").then(
              function(res) {
                if (res.data.result != 0) {
                  this.$alert('用户名已存在', '提示', {
                    confirmButtonText: '确定',
                    callback: action => {
                      vm.messageCodeText = "获取验证码";
                      vm.mobileBtnDisabled = false;
                    }
                  });

                } else {
                  vm.$axios.get("/signin/sendMessage?phone=" + vm.registerForm.username).then(function(res) {
                      vm.messageCodeReal = res.data.msg;
                      var count = vm.time;
                      vm.timer = setInterval(() => {
                        if (count == 0) {
                          clearInterval(vm.timer);
                          vm.timer = null;
                          vm.messageCodeText = "获取验证码";
                          vm.mobileBtnDisabled = false;
                        } else {
                          vm.messageCodeText = count + "秒后获取";
                          count--;
                          vm.mobileBtnDisabled = true;
                        }
                      }, 1000);
                    }.bind(vm),
                    function(error) {
                      console.log(error);
                    }
                  );
                }
              }.bind(vm),
              function(error) {
                console.log(error);
              }
            );
          }


        }
      },
    }
  };
</script>
<style lang="scss">
  #registermain {
    .div1 {
      display: block;
      position: absolute;
      right: 0;
      bottom: 3rem;
      text-align: right;
    }

    .span1 {
      font-size: 1rem;
      color: #409eff;
      display: inline-block;
      width: auto;
      height: auto;
    }

    .span2 {
      margin-left: 0.5rem;
      float: right;
      font-size: 1rem;
      color: #409eff;
      display: inline-block;
      width: auto;
      height: auto;
    }

    .item1 {
      width: 100%;
      text-align: left;
      font-size: 1rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/login/RegisterMain.vue